import { PromptGroup_deprecated } from '@server/prompts';
import { PromptGroupCardContent } from './PromptGroupCardContent';

interface PromptCardProps {
  promptGroup: PromptGroup_deprecated;
  onClick: (promptCard: PromptGroup_deprecated) => void;
}

export const PromptCard = ({ promptGroup, onClick }: PromptCardProps) => {
  return <PromptGroupCardContent onClick={onClick} promptGroup={promptGroup} />;
};
